import { useEffect, useState } from 'react';
import { RefreshCw, X } from 'lucide-react';
import { applyUpdate, subscribeUpdate } from '../pwa/update';

/**
 * "A new version is ready" toast. Appears when a new service worker is
 * waiting OR when the server's index.html names a newer bundle than the one
 * running (pwa/update.ts version check, 15 Oct 2026); reload happens ONLY
 * when the user taps (never mid-typing).
 * Dismissing hides it for this page load — it returns on the next visit,
 * since the update really is still pending.
 */
export function UpdateToast() {
  const [ready, setReady] = useState(false);
  const [hidden, setHidden] = useState(false);

  useEffect(() => subscribeUpdate(setReady), []);

  if (!ready || hidden) return null;

  return (
    <div
      role="status"
      className="fixed inset-x-0 bottom-4 z-50 mx-auto flex w-fit max-w-[92vw] items-center gap-2.5 rounded-2xl border border-brand-300 dark:border-brand-500/40 bg-white dark:bg-slate-900 px-3.5 py-2.5 shadow-lg shadow-slate-900/10 dark:shadow-black/40"
    >
      <RefreshCw size={15} className="shrink-0 text-brand-600 dark:text-brand-400" />
      <span className="text-xs font-medium text-slate-700 dark:text-slate-300">
        ZoneIn was updated
      </span>
      <button
        onClick={applyUpdate}
        className="shrink-0 rounded-lg bg-brand-600 px-3 py-1.5 text-[11px] font-bold text-white transition-colors hover:bg-brand-500"
      >
        Reload now
      </button>
      <button
        onClick={() => setHidden(true)}
        aria-label="Not now"
        className="shrink-0 rounded-lg p-1 text-slate-500 transition-colors hover:bg-slate-100 dark:hover:bg-slate-800"
      >
        <X size={13} />
      </button>
    </div>
  );
}
